module.exports = __webpack_public_path__ + "media/images/branchIcon-67d98621.svg";